import SwimlanePublishedModal from './SwimlanePublishedModal';

export default SwimlanePublishedModal;
